/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import { RouteObject } from "react-router-dom"

import Home from './Main/Home';
import Contact from './Main/Contact';
import NotFound from './Main/NotFound';
import Project from './Main/Project';
import Skill from './Main/Skill';
import Blog from "./Main/Blog";
import Content from "./Main/Blog/Content";
import Main from "./Main";

export default [
  {
    path: "/",
    element: <Main />,
    errorElement: <Main><NotFound /></Main>,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: 'blog',
        element: <Blog />
      },
      {
        path: 'blog/:id',
        element: <Content />
      },
      {
        path: 'skills',
        element: <Skill />
      },
      {
        path: 'skills/:type',
        element: <Skill />
      },
      {
        path: 'projects',
        element: <Project />
      },
      {
        path: 'contact',
        element: <Contact />
      }
    ]
  },
] as RouteObject[]